import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--up",
  "use": "icon-arrow--up-usage",
  "viewBox": "0 0 12 7",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 7\" id=\"icon-arrow--up\"><path d=\"M6.677 1.625a.957.957 0 0 0 0-1.346.94.94 0 0 0-1.337 0L.294 5.357c-.892.898.446 2.245 1.338 1.347l5.045-5.079H5.34l5.045 5.079a.942.942 0 0 0 1.338 0 .957.957 0 0 0 0-1.347L6.677.28a.94.94 0 0 0-1.337 0L.294 5.357l1.338 1.347 5.045-5.079Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol